var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"la-ball-spin-clockwise mx-auto",class:_vm.extraClass},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }